"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Paper_1 = require("@material-ui/core/Paper");

var Table_1 = require("@material-ui/core/Table");

var TableHead_1 = require("@material-ui/core/TableHead");

var TableRow_1 = require("@material-ui/core/TableRow");

var makeStyles_1 = require("@material-ui/styles/makeStyles");

var React = require("react");

var uno_material_ui_1 = require("uno-material-ui");

var uno_react_1 = require("uno-react");

var useDataGrid_1 = require("../Hooks/useDataGrid");

var Pagination_1 = require("../Pagination");

var GridToolbar_1 = require("../Toolbar/GridToolbar");

var ToolbarOptions_1 = require("../Toolbar/ToolbarOptions");

var _1 = require("./");

var MobileDataGridTable_1 = require("./MobileDataGridTable");

var useStyles = makeStyles_1["default"]({
  linearProgress: {
    marginTop: '-10px'
  },
  root: {
    overflowX: 'auto',
    width: '100%'
  }
});
var outerWidth = 800;
var timeout = 400;

exports.DataGrid = function (props) {
  var bodyRenderer = props.bodyRenderer,
      columns = props.columns,
      deps = props.deps,
      footerRenderer = props.footerRenderer,
      dataSource = props.dataSource,
      _a = props.toolbarOptions,
      toolbarOptions = _a === void 0 ? props.toolbarOptions || new ToolbarOptions_1.ToolbarOptions() : _a,
      gridName = props.gridName,
      onError = props.onError,
      onRowClick = props.onRowClick,
      storage = props.storage;
  var classes = useStyles({});
  var gridConfig = {
    gridName: gridName,
    itemsPerPage: toolbarOptions.itemsPerPage,
    onError: onError,
    storage: storage
  };
  var grid = useDataGrid_1["default"](columns, gridConfig, dataSource, deps);
  var isMobileResolution = uno_react_1.useResolutionSwitch(outerWidth, timeout)[0];

  if (isMobileResolution) {
    toolbarOptions.SetMobileMode();
    return React.createElement(Paper_1["default"], {
      className: classes.root
    }, React.createElement(GridToolbar_1.GridToolbar, {
      toolbarOptions: toolbarOptions,
      grid: grid,
      gridName: gridName
    }), React.createElement(uno_material_ui_1.FixedLinearProgress, {
      isLoading: grid.state.isLoading
    }), React.createElement(MobileDataGridTable_1.MobileDataGridTable, {
      grid: grid,
      onRowClick: onRowClick
    }), React.createElement(Pagination_1.Paginator, {
      advancePagination: toolbarOptions.advancePagination,
      rowsPerPageOptions: toolbarOptions.rowsPerPageOptions,
      grid: grid
    }));
  }

  var paginator = function paginator(position) {
    return React.createElement(Table_1["default"], {
      "data-testid": position + "-paginator"
    }, React.createElement(TableHead_1["default"], null, React.createElement(TableRow_1["default"], null, React.createElement(Pagination_1.Paginator, {
      advancePagination: toolbarOptions.advancePagination,
      rowsPerPageOptions: toolbarOptions.rowsPerPageOptions,
      grid: grid
    }))));
  };

  return React.createElement(Paper_1["default"], {
    className: classes.root
  }, React.createElement(GridToolbar_1.GridToolbar, {
    gridName: gridName,
    toolbarOptions: toolbarOptions,
    grid: grid
  }), toolbarOptions.topPager && paginator('top'), React.createElement("div", {
    className: classes.linearProgress,
    "data-testid": 'linear-progress'
  }, React.createElement(uno_material_ui_1.FixedLinearProgress, {
    isLoading: grid.state.isLoading
  })), React.createElement(_1.DataGridTable, {
    grid: grid,
    bodyRenderer: bodyRenderer,
    footerRenderer: footerRenderer,
    onRowClick: onRowClick
  }), toolbarOptions.bottomPager && paginator('bottom'));
};